





















































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import UserDocsForm from '@/components/users/user-docs-form.vue';
import UserForm from '@/components/users/user-form.vue';
import { cpfFormat } from '@/helpers/cpfFormat';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { UsuarioFiltroParmDTO } from '@/interfaces/user';
import { getLocalUser } from '@/services/session-data';
import * as service from '@/services/users';
import { STATUS_LIST_VALUE_LABEL } from '@/settings/consts/commons';
import {
  ACCESS_TYPE_CLIENT,
  ACCESS_TYPE_EMEDE,
  TYPES_ACCESS_VALUE_LABEL,
  TYPES_USERS_VALUE_LABEL,
  USER_TYPE_DOCTOR,
  USER_TYPE_OTHER
} from '@/settings/consts/users';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import TextHighlight from 'vue-text-highlight';
import UserActivationForm from './activation-form.vue';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    UserForm,
    UserDocsForm,
    UiAutocompleClientsSubsidiaries,
    UserActivationForm,
    TextHighlight
  },
})
export default class Users extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;
  private formDocsOpen:boolean =false;
  private tokenDocs: string = null; 
  private uuid:string = null;

  public filter: any = {
    term: '',
    oldTerm: null,
    clientUnit: null,
    profile: null,
    typeAccess: null,
    typeUser: null,
    status: null,
  };

  typesAccess:any = TYPES_ACCESS_VALUE_LABEL;
  statusList: any = STATUS_LIST_VALUE_LABEL;

  tpUserOther = USER_TYPE_OTHER;

  public profiles: any[] = [];
  public userTypesLoading = false;
  public userTypes = [];

  public headers: any = [
    { text: 'CPF / CRM', value: 'cpfCrm' },
    { text: 'Nome', value: 'nome' },
    { text: 'E-mail', value: 'email' },
    { text: 'Perfil', value: 'perfil' },
    {
      text: 'Tipo de usuário',
      value: 'userType.description',
      sortable: false,
      align: 'center',
      width: 100,
      class: ['px-0', 'mx-0'],
    },
    {
      text: 'Tipo de Acesso',
      value: 'accessType.description',
      sortable: false,
      align: 'center',
      width: 100,
      class: ['px-0', 'mx-0'],
    },
    { text: 'Ações', value: 'actions', sortable: false, align: 'right' },
  ];
  public data: any[] = [];
  public idSelected = null;
  public currentUserId: string = null;

  private showActivationModal:boolean = false;
  private activationUserId:String = null;

  private alterUnitOnly:boolean = false;

  statusActivationOptions = [];

  public pagination: PaginationSyncDTO = new PaginationSyncDTO();

  public beforeMount(): void {
    this.load();
    this.getUserTypes();
    this.getProfiles();
    if (!this.isEmede()) {
      this.filter.typeAccess = ACCESS_TYPE_CLIENT;
    }
    getLocalUser().subscribe((currentUser) => {
      this.currentUserId = currentUser.idLogin;
    });

    service.listUserStatusActivationOptions().subscribe(res => {
      this.statusActivationOptions = res;
    }, error => {
      this.showToastApiError(error);
    })
  }

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  public mounted(): void {
    this.uuid = this.$route.query.uuid ? this.$route.query.uuid.toString() : null;
    if (this.uuid) {
      this.showUserDocsForm(this.uuid);
    }    

    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.getUsers(filter);
        }),
      )
      .subscribe((data) => {
        if (!!data) {
          PaginationSyncDTO.update(this.pagination, data);
          this.data = data.content.map((item) => {
            const userTypeDoctor = {
              icon: 'fa-user-md',
              description: 'Médico',
            };
            const userTypeOther = {
              icon: 'fa-user',
              description: 'Usuário',
            };
            const accessTypeEmede = {
              icon: 'fa-building',
              description: 'EMEDE',
            };
            const accessTypeClient = {
              icon: 'fa-hospital-alt',
              description: 'Cliente',
            };

            const document =
              item.tipoLogin === USER_TYPE_DOCTOR
                ? `${item.crm}${item.crmUF}`
                : cpfFormat(item.cpf);
            const userType =
              item.tipoLogin === USER_TYPE_DOCTOR
                ? userTypeDoctor
                : userTypeOther;
            const accessType =
              item.tipoAcesso === ACCESS_TYPE_EMEDE
                ? accessTypeEmede
                : accessTypeClient;

            return {
              ...item,
              document,
              documentSearch: document.replace(/[^a-z0-9]/gi, ''),
              accessType,
              userType,
              tipoAcessoCliente: item.tipoAcesso != ACCESS_TYPE_EMEDE,
              doctor: item.tipoLogin === USER_TYPE_DOCTOR
            };
          });
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }

  

  public onEditItem(item: any): void {
    this.idSelected = item.id;
    this.formOpen = true;
    this.formIsEdit = true;
  }

  public saveItem(): void {
    this.closeForm();
    this.load();
  }

  public showActivationUser(item, status: boolean): void {    
    this.activationUserId = item.id;
    this.showActivationModal = true;
  }

  public onCloseActivationModal() {
    this.activationUserId = null;
    this.showActivationModal = false;
  }

  private onAfterSaveActivation(){
    this.onCloseActivationModal();
    this.load();
  }

  public showAlterUnitUser(item): void {        
    this.alterUnitOnly = true;
    this.onEditItem(item);
  }

  public newItem(): void {
    this.idSelected = null;
    this.formOpen = true;
    this.formIsEdit = false;
  }

  public closeForm(): void {
    this.idSelected = null;
    this.formOpen = false;
    this.alterUnitOnly = false;
    resetModalScroll();
  }

  private lastFilter = null;

  private buildFilterParm() {
    let parm = new UsuarioFiltroParmDTO();
    let filter = this.filter;

    parm.idUnidadeCliente = filter.clientUnit && filter.clientUnit.id ? filter.clientUnit.id : null;
    parm.nomeEmailCpfCrm = filter.term;
    filter.oldTerm = filter.term;
    parm.tipoAcesso = filter.typeAccess;
    parm.ativo = filter.status;
    parm.tipoLogin = filter.typeUser;
    parm.idPerfil = filter.profile ? filter.profile.id : null;
    parm.situacaoEfetivacao = filter.typeUser != this.tpUserOther ? filter.statusActivation : null;

    if (this.lastFilter && JSON.stringify(this.filter) != JSON.stringify(this.lastFilter)) {
      this.pagination.page = 1;
    }
    this.lastFilter = {... filter};

    parm.update(this.pagination);
    return parm;
  }

  private load(): void {
    this.data = [];
    this.loading = true;
    this.error = false;

    let filters = this.buildFilterParm();
    this.execBehaviorSub$.next(filters);    
  }

  @Watch('filter.typeUser')
  onChangeTypeUser() {
    this.filter.statusActivation = null;
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangeFilter(val) {
    this.load();
  }

  private getProfiles(): void {
    const filter = {
      tipo: null,
    };

    service.listUserProfiles().subscribe((data) => {
      this.profiles = data;
    });
  }

  private getUserTypes(): void {
    this.userTypesLoading = true;
    service.listUserLoginTypes().subscribe((data) => {
      this.userTypes = data;
      this.userTypesLoading = false;
    }, error => {
      this.showToastApiError(error);
      this.userTypesLoading = false;
    });
  }


  private confirmSendMailAccess(item: any): void {
    let instance = this;
    this.dialog.show(
      'alert',
      null,
      'Deseja enviar e-mail de redefinição de senha para ' + item.nome + '?',
      'Enviar e-mail',
      function() {
        instance.loader.start('Enviando email de acesso ...');
        instance.addSubsc(
          service.sendAccessEmail(item.id).subscribe(
            (msg) => {
              instance.loader.stop();
              instance.toast.show(msg, 'success');
            },
            (error) => {
              instance.loader.stop();
              instance.toast.show(error.data.message, 'error');
            },
          ),
        );
      },
      'Cancelar'
    );
  }

  private confirmResendEmailPreActivation(item: any): void {
    let instance = this;
    this.dialog.show(
      'alert',
      null,
      'Deseja reenviar o e-mail de Termos de Uso para ' + item.nome + '?',
      'Enviar e-mail',
      function() {
        instance.loader.start('Enviando email ...');
        instance.addSubsc(
          service.resendPreActivationUserEmail(item.tokenUsuarioDocumentos).subscribe(
            (msg) => {
              instance.loader.stop();
              instance.toast.show(msg, 'success');
            },
            (error) => {
              instance.loader.stop();
              instance.toast.show(error.data.message, 'error');
            },
          ),
        );
      },
      'Cancelar'
    );
  }

  private showUserDocsForm(token:string) {
    this.tokenDocs = token;
    this.formDocsOpen = true;
  }

  private closeUserDocsForm() {
    this.tokenDocs = null;
    this.formDocsOpen = false;
    this.$router.push("/usuarios");    
  }

  private onAfterSaveUserDocsForm() {
    this.closeUserDocsForm();
    this.load();
  }

}
